import React from "react";
import { Link } from "react-router-dom";

import { Logo } from "components/atoms/logo/index";
import * as S from "./header.styles";

export const Header = (props) => {
  return (
    <S.HeaderNav company={props.company.name}>
      <Link to="/" aria-label="Home">
        <Logo alt="Simple tax" company={props.company} />
      </Link>
    </S.HeaderNav>
  );
};
